import React from 'react';

/**
 * renderInlineBold — converts **keyword** markers to <strong> React nodes.
 *
 * Usage: {renderInlineBold("Experienced in **React** and **TypeScript**")}
 *
 * Returns ReactNode[] — safe to render directly in JSX.
 * Text without markers returns a single string node (no overhead).
 */
export function renderInlineBold(text: string): React.ReactNode[] {
  const BOLD_RE = /\*\*(.*?)\*\*/g;

  // Fast path: no markers
  if (!text.includes('**')) return [text];

  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let keyIdx = 0;

  while ((match = BOLD_RE.exec(text)) !== null) {
    // Text before match
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    // Bold node
    nodes.push(React.createElement('strong', { key: keyIdx++ }, match[1]));
    lastIndex = match.index + match[0].length;
  }

  // Remaining text after last match
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}
